import { render, staticRenderFns } from "./YHeaderExpert.vue?vue&type=template&id=4fab5031&scoped=true&"
import script from "./YHeaderExpert.vue?vue&type=script&lang=js&"
export * from "./YHeaderExpert.vue?vue&type=script&lang=js&"
import style0 from "./YHeaderExpert.vue?vue&type=style&index=0&id=4fab5031&lang=scss&scoped=true&"
import style1 from "./YHeaderExpert.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fab5031",
  null
  
)

export default component.exports